/* eslint-disable react/no-danger */
import React from "react";
import PropTypes from "prop-types";
import СreateDOMPurify from "dompurify";
import classnames from "classnames/bind";

import styles from "./MessageBody.scss";

const cx = classnames.bind(styles);

const MessageBody = ({ message, partnerId, partnerName }) => (
  <div className={cx("show-more-text")}>
    <div className={cx("text-panel")}>
      <p
        dangerouslySetInnerHTML={{
          __html: СreateDOMPurify.sanitize(message),
        }}
        className={cx({
          "auto-mailing": partnerId && partnerName,
        })}
      />
    </div>
  </div>
);

MessageBody.propTypes = {
  message: PropTypes.string,
  partnerId: PropTypes.number,
  partnerName: PropTypes.string,
};

export default MessageBody;
